import { useCallback, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLlmChatContext } from '~/components/llm/llmChatContext'
import { toastError } from '~/components/toasts'
import llmChatCreateDefinition from '~/packages/llmChat/create/llmChatCreate.definition'
import useActionFunction from '~/prix/react/hooks/actionFunction'

const MAX_CHAT_TITLE_LENGTH = 255

function truncateChatTitle(question: string) {
  if (question.length <= MAX_CHAT_TITLE_LENGTH) {
    return question
  }

  return `${question.slice(0, MAX_CHAT_TITLE_LENGTH - 3)}...`
}

export default function useAskPrixAi() {
  const navigate = useNavigate()
  const { refreshChatList } = useLlmChatContext()
  const isCreatingChatRef = useRef(false)

  const { callAction: createChat, isLoading } = useActionFunction(llmChatCreateDefinition, {
    initialIsLoading: false,
  })

  const askPrixAi = useCallback(
    async (rawQuestion: string) => {
      const question = rawQuestion.trim()
      if (!question || isCreatingChatRef.current) {
        return
      }

      isCreatingChatRef.current = true

      try {
        const { resultPromise } = createChat({ title: truncateChatTitle(question) })
        const result = await resultPromise

        await refreshChatList()
        navigate(`/app/ai/${result.id}`)
      } catch (error) {
        console.error('Erro ao abrir a Prix IA:', error)
        toastError('Não foi possível abrir a Prix IA')
      } finally {
        isCreatingChatRef.current = false
      }
    },
    [createChat, navigate, refreshChatList],
  )

  return {
    askPrixAi,
    isLoading,
  }
}
